import { useTranslation } from 'libs/i18n'
import { HistoryTable } from 'shared/components'
import { BackButton, Header } from 'shared/components'
import { useParams } from 'libs/router'
import { routes } from 'config/routes'
import { useFetchBookingHistory } from './queries/useFetchBookingHistory'

const BookingHistory = () => {
	const { t } = useTranslation()
	const params = useParams()
	const { bookingHistory, isBookingHistoryLoading } = useFetchBookingHistory()

	return (
		<>
			<Header
				title={t('Booking / History')}
				eyebrow={t('Bookings')}
				actions={<BackButton to={routes.bookingEdit(params.id)} />}
			/>
			<HistoryTable results={bookingHistory?.data} isLoading={isBookingHistoryLoading} />
		</>
	)
}

export default BookingHistory
